module.exports = __webpack_public_path__ + "media/images/brand/logo-reverse-95411c4cd2377609ba9488533af23ae9.svg";